import { mapState } from 'vuex';

export default  {	
	data () {
		return { 
			active: 1

		}
	},
	created () { 
	},
	methods: {
			
		
		
	}
}
